<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="getReportByFilters($event)"
></mt-filter>

<div *ngIf="showAlert" class="alert-container">
    <ngb-alert [dismissible]="false">
        <div>{{ "m079" | lang }} {{ numberOfReports }} reportes.</div>
        <div *ngIf="numberOfReports > 0">
            No existen registros para los siguientes equipos:
            {{ machineWithoutData }}
        </div>
    </ngb-alert>
</div>
